
export default "/assets/rss-mini.aa80e1f2.svg"